import { UnionSmallIcon } from "@/assets/images/svgIcons/unionSmallIcon"
import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import OnboardingBoxStripe from "@images/payment/onboardingBoxStripe.svg"
import { word } from "@modules/core/utils/i18n"
import { ArrowRightIcon } from "lucide-react"

export function BoxOnboardingStripeFirstPage({
  handleNextPageNavigation,
  handleButtonTryLiteVersion,
}: {
  handleNextPageNavigation: () => void
  handleButtonTryLiteVersion: () => void
}) {
  return (
    <div className="relative flex h-screen w-full flex-col justify-between p-12">
      {/* HEARDER */}
      <div className="flex w-full flex-col items-center gap-2 text-center">
        <UnionSmallIcon color="currentColor" />

        <Text fontStyle="HL" className="mt-5">
          {word("box.stripe.onboarding.title")}
        </Text>
        <Text fontStyle="BL">{word("box.stripe.onboarding.screen1.subtitle")}</Text>
      </div>
      {/* CONTENT */}
      <div className="my-4 flex grow flex-col items-center justify-center gap-6 sm:flex-row">
        {/* ILLUSTRATION FOR SMALL DEVICE  */}
        <div
          className="h-10rem flex w-full grow flex-row items-center justify-center bg-contain bg-center bg-no-repeat sm:hidden"
          style={{ backgroundImage: `url('${OnboardingBoxStripe} ')` }}
        ></div>
        {/* LEFT */}
        <div className="flex w-11/12 flex-col sm:w-1/2 md:w-5/12 lg:w-1/3 xl:w-1/4">
          <Text fontStyle="HM">{word("box.stripe.onboarding.screen1.content")}</Text>

          <Button
            variant="primary"
            size="lg"
            onClick={() => {
              handleNextPageNavigation()
            }}
            className="mt-4 w-fit"
          >
            {word("box.stripe.onboarding.screen1.button")}
            <ArrowRightIcon color="currentColor" />
          </Button>
        </div>
        {/* RIGHT */}
        <div
          className="h-20rem hidden h-full w-1/3 bg-contain bg-center bg-no-repeat sm:flex xl:w-1/4 xl:justify-center"
          style={{ backgroundImage: `url('${OnboardingBoxStripe} ')` }}
        ></div>
      </div>
      {/* LITE VERSION */}
      <div className="mx-auto mb-8 flex w-11/12 flex-col justify-center gap-4 rounded-3xl bg-neutral-100 p-6 sm:flex-row sm:items-center sm:gap-2 md:w-9/12 xl:w-7/12">
        <Text fontStyle="BM" className="w-full sm:w-8/12">
          {word("box.stripe.onboarding.screen1.liteVersion.description")}
        </Text>
        <Button
          variant="outline"
          size="lg"
          onClick={() => handleButtonTryLiteVersion()}
          className="h-3rem bg-transparent"
        >
          {word("box.stripe.onboarding.screen1.liteVersion.button")}
        </Button>
      </div>
    </div>
  )
}
